import React, { useCallback } from 'react';
import styled from 'styled-components';
import { alarmsSettingsTypes } from '../../../constants/data.types';
import alarmsStore from '../../../stores/alarms.store';
import { EuiSwitch } from '@elastic/eui';
import { addToast } from '../toasts/Toast';

const ItemStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 4px 0;
  }

  .desc-header {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.5;
    margin: 0 0 12px 0;
  }
`;

const ToggleRowStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.08);
  }

  .text-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-right: 16px;
    text-align: left;
  }

  .title {
    font-size: 15px;
    font-weight: 600;
    color: #fff;
  }

  .description {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
    line-height: 1.4;
  }

  .switch-wrapper {
    flex-shrink: 0;
  }
`;

const ALARM_DESCRIPTIONS = {
    cpu_high: "Receive an alert if CPU usage spikes to maximum capacity (100%).",
    sessions_high: "Get notified when active client or user sessions increase significantly.",
    connections_high: "Alert on sudden spikes in concurrent TCP/network connections.",
    high_ram_80: "Warning alert when system memory usage exceeds 80% capacity.",
    high_ram_90: "Critical alert when memory utilization exceeds 90%.",
    high_disk_80: "Warning alert when storage disk space reaches 80% capacity.",
    high_disk_90: "Critical alert when storage volume is 90% full.",
    rx_high: "Notification when incoming network bandwidth exceeds normal levels.",
    tx_high: "Notification when outgoing network traffic spikes abnormally."
};

const AlarmsSettings = ({ serverAlarmsSettings }) => {
    const handleSettingsChange = useCallback(async (key, data) => {
        try {
            await alarmsStore.updateAlarmsSettings({
                type: key,
                status: data,
                serverId: serverAlarmsSettings.serverId
            });
            addToast('Alarms settings changed', 'suc');
        } catch (error) {
            addToast(error.message || 'Failed to change alarms settings', 'error');
        }
    }, [serverAlarmsSettings]);

    return (
        <ItemStyles>
            <h3>Alarms notifications</h3>
            <p className="desc-header">Set type of alarm you prefer to get notification.</p>

            <ToggleRowStyled>
                <div className="text-content">
                    <span className="title">Server is down</span>
                    <span className="description">Always enabled. Notifies immediately when the agent stops sending data.</span>
                </div>
                <div className="switch-wrapper">
                    <EuiSwitch
                        label="On"
                        onChange={ () => null }
                        checked={ true }
                        disabled={ true }
                    />
                </div>
            </ToggleRowStyled>

            { alarmsSettingsTypes.map((item, idx) => {
                return (
                    <ToggleRowStyled key={ idx + 'zkkdw' }>
                        <div className="text-content">
                            <span className="title">{ item.title }</span>
                            <span className="description">
                                { ALARM_DESCRIPTIONS[item.key] || `Receive notifications for ${ item.title.toLowerCase() }.` }
                            </span>
                        </div>
                        <div className="switch-wrapper">
                            <EuiSwitch
                                label={ serverAlarmsSettings[item.key] ? 'On' : 'Off' }
                                checked={ !!serverAlarmsSettings[item.key] }
                                onChange={ () => handleSettingsChange(item.key, !serverAlarmsSettings[item.key]) }
                            />
                        </div>
                    </ToggleRowStyled>
                );
            }) }
        </ItemStyles>
    );
};

export default AlarmsSettings;
